import { ClientSideStorageService } from '../client-side-storage.service';
import { ClientSideStorageType } from '../../models/client-side-storage-type.enum';
import GrafanaLogService from './grafana-log.service';
import { ConfigurationService } from '../configuration.service';

export default class LogService {
  public static readonly disableLoggingCssClassName = 'disable-logging';
  public static readonly version = '2.3.20'; // Placeholder for version number, replaced during deployment

  private static isDevelopmentMode: boolean = false;

  public static init() {
    LogService.isDevelopmentMode = ConfigurationService.get('environment') === 'development';
    GrafanaLogService.init(LogService.version);
  }

  public static logInfo(message?: string) {
    if (!GrafanaLogService.isEnabled()) {
      if (LogService.isDevelopmentMode) {
        console.log(message);
      }
      return;
    }
    if (!ClientSideStorageService.isConsentGiven(ClientSideStorageType.Analytics)) return;
    GrafanaLogService.logInfo(message);
  }

  public static logError(error: unknown, logMessage?: string) {
    if (!GrafanaLogService.isEnabled()) {
      if (LogService.isDevelopmentMode) {
        console.error(logMessage, error);
      }
      return;
    }
    if (!ClientSideStorageService.isConsentGiven(ClientSideStorageType.Analytics)) return;
    GrafanaLogService.logError(error, logMessage);
  }
}
